import React from 'react';
import { Navigate } from 'react-router-dom';
import useAuth from '../useAuth';

const AuthorizationCheck = ({ children, restrictedRoles = [] }) => {
  const { user } = useAuth();
  
  // If user is logged in and their role is in the restricted list, redirect
  if (user && restrictedRoles.includes(user.userType.toLowerCase())) {
      return <Navigate to="/my/home" replace />;
  }

  return children;
};

export default AuthorizationCheck;
